
import { mapGetters } from "vuex";
import { SistemaMixin } from "@/modules/Application";
import { Money } from "v-money";
import { priceOptions } from "@/modules/Application";

export default {
  name: "VariacaoModal",
  mixins: [SistemaMixin],
  components: {
    Money,
  },
  props: {
    produto: {
      type: Object,
    },
    addProduto: {
      type: Function,
    },
    preco: {
      type: Number,
      default: 0,
    },
    quantidadeInicial: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      allCombinations: [],
      variacoes: null,
      combinacao: {
        quantidade: 1,
      },
      combinacaoSelected: null,
      foraDeEstoque: false,
      precoEdit: "",
      priceOptions,
    };
  },
  methods: {
    normalizarQuantidade() {
      let qtd = Number(this.combinacao.quantidade) || 0;
      if (qtd < 0) qtd = 0;
      this.combinacao.quantidade = qtd;
    },

    handleAddProdutoVariavel() {
      if (!this.combinacaoSelected) {
        this.$toast.warning("Selecione a variação desejada!");
        return;
      }

      this.normalizarQuantidade();

      if (!this.combinacao.quantidade || this.combinacao.quantidade === 0) {
        this.$toast.warning("Adicione pelo menos uma unidade");
        return;
      }

      const precoNumber = this.formatNumberToFloat(this.precoEdit || this.preco || 0);
      const combinacaoSelecionada = this.allCombinations.find((item) => {
        return Object.keys(this.combinacao).every((key) => {
          if (key === "quantidade") return true;
          return item[key] === this.combinacao[key];
        });
      });

      const produtoAtualizado = {
        ...this.produto,
        combinacao: this.combinacao,
        quantidade_original_combinacao: combinacaoSelecionada?.quantidade,
        preco: precoNumber,
        quantidade: this.combinacao.quantidade,
      };

      this.$emit("onAddProduto", {
        newPreco: precoNumber,
        newQuantidade: this.combinacao.quantidade,
        newTotal: precoNumber * this.combinacao.quantidade,
        newProduto: produtoAtualizado,
      });

      this.combinacao = { quantidade: 1 };
      this.combinacaoSelected = "";
      this.precoEdit = "";
      this.$bvModal.hide("variacaoModal");
    },

    handleChangeVariacao(index) {
      if (index !== 0 || this.variacoes.labels.length === 1) return;
      const aux = Object.keys(this.combinacao)[index];
      this.combinacao[aux] = null;
    },

    findEstoque(label, option, index) {
      if (this.variacoes.labels.length === 1) {
        const variacaoChosed = this.allCombinations.find(
          (el) => el[label] === option
        );
        // aqui você pode usar variacaoChosed.quantidade se quiser bloquear por estoque
      }

      if (index === 0) return;

      const otherLabel = Object.keys(this.combinacao).find(
        (el) => el !== label
      );
      const variacaoChosed = this.allCombinations
        .filter((el) => el[otherLabel] === this.combinacao[otherLabel])
        .find((el) => el[label] === option);

      const quantidadeOfChooseElement = this.allCombinations.find(
        (el) =>
          el[label] === this.combinacao[label] &&
          el[otherLabel] === this.combinacao[otherLabel]
      )?.quantidade;

      return false;
    },

    async handleProdutoVariavel() {
      this.loading = true;
      if (this.quantidadeInicial !== null) {
        this.combinacao = {
          quantidade: Math.max(1, Number(this.quantidadeInicial) || 1),
        };
      }
      try {
        const { data } = await this.$http.post("/produtos/get-combinacao", {
          id_produto: this.produto.id,
        });

        const combinacao = data.combinacao;
        this.allCombinations = combinacao;

        const variacoesLabel = Object.keys(combinacao[0]).filter(
          (element) => element !== "quantidade"
        );

        let variacoes = {
          labels: variacoesLabel,
        };

        variacoesLabel.forEach((variacao) => {
          this.combinacao = {
            [variacao]: null,
            ...this.combinacao,
          };

          const aux = combinacao.reduce((acc, el) => {
            if (acc.includes(el[variacao])) return acc;
            else return [...acc, el[variacao]];
          }, []);

          variacoes = {
            ...variacoes,
            [variacao]: aux,
          };
        });

        this.variacoes = variacoes;

        // carrega o preço atual do produto no input
        this.precoEdit = this.numberToReal(this.produto?.preco || 0);
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    },
  },
  watch: {
    combinacao: {
      handler(newCombinacao, oldCombinacao) {
        const string = [];
        for (const selection in this.combinacao) {
          if (this.combinacao[selection] && selection !== "quantidade")
            string.push(this.combinacao[selection]);
        }
        this.combinacaoSelected =
          string.length > 0 ? string.reverse().join("/") : "";
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
  },
};
